import { createVNode, createComponentVNode, createTextVNode } from "inferno";
import Input from 'dmn-js-shared/lib/components/Input';
import InputSelect from 'dmn-js-shared/lib/components/InputSelect';
import { withChangeSupport } from '../../../util/withChangeSupport';
export const FunctionDefinitionEditorComponent = withChangeSupport(_FunctionDefinitionEditorComponent, props => [props.expression]);
function _FunctionDefinitionEditorComponent({
  expression
}, context) {
  const parameters = expression.get('formalParameter');
  const body = expression.get('body');
  const modeling = context.injector.get('modeling'),
    dmnFactory = context.injector.get('dmnFactory');
  const addParameter = () => {
    const parameter = dmnFactory.create('dmn:InformationItem', {
      name: '',
      typeRef: ''
    });
    modeling.updateProperties(expression, {
      formalParameter: parameters.concat(parameter)
    });
  };
  const removeParameter = parameter => {
    modeling.updateProperties(expression, {
      formalParameter: parameters.filter(e => e !== parameter)
    });
  };
  return createVNode(1, "div", "function-definition", [createComponentVNode(2, FormalParameters, {
    "add": addParameter,
    "remove": removeParameter,
    "parameters": parameters
  }), createComponentVNode(2, BodyExpression, {
    "expression": body
  })], 4);
}
function FormalParameters({
  add,
  parameters,
  remove
}) {
  return createVNode(1, "div", "function-definition-parameters", [createVNode(1, "h2", null, createTextVNode("Parameters"), 2), createVNode(1, "table", null, [createVNode(1, "thead", null, createVNode(1, "tr", null, [createVNode(1, "th", null, createTextVNode("Name"), 2), createVNode(1, "th", null, createTextVNode("Type"), 2)], 4), 2), createVNode(1, "tbody", null, parameters.map((parameter, idx) => createComponentVNode(2, Parameter, {
    "parameter": parameter,
    "remove": () => remove(parameter)
  }, idx)), 0)], 4), createVNode(1, "button", null, createTextVNode("Add parameter"), 2, {
    "type": "button",
    "onClick": add
  })], 4);
}
const Parameter = withChangeSupport(function ({
  parameter,
  remove
}, context) {
  const modeling = context.injector.get('modeling');
  const dataTypes = context.injector.get('dataTypes');
  const translate = context.injector.get('translate');
  const onNameChange = name => {
    modeling.updateProperties(parameter, {
      name
    });
  };
  const onTypeRefChange = typeRef => {
    modeling.updateProperties(parameter, {
      typeRef
    });
  };
  const typeRefOptions = dataTypes.getAll().map(t => {
    return {
      label: translate(t),
      value: t
    };
  });
  return createVNode(1, "tr", "function-definition-parameter", [createVNode(1, "td", null, createComponentVNode(2, Input, {
    "onInput": onNameChange,
    "value": parameter.get('name')
  }), 2), createVNode(1, "td", null, createComponentVNode(2, InputSelect, {
    "onChange": onTypeRefChange,
    "value": parameter.get('typeRef'),
    "options": typeRefOptions
  }), 2), createVNode(1, "td", null, createVNode(1, "button", null, createTextVNode("Remove"), 2, {
    "type": "button",
    "onClick": remove
  }), 2)], 4);
}, props => [props.parameter]);
function BodyExpression({
  expression
}, context) {
  const Expression = context.components.getComponent('expression', {
    expression
  });
  return createVNode(1, "div", "function-definition-body", [createVNode(1, "h2", null, createTextVNode("Expression"), 2), createComponentVNode(2, Expression, {
    "expression": expression
  })], 4);
}
//# sourceMappingURL=FunctionDefinitionEditorComponent.js.map